// extracted by mini-css-extract-plugin
export default {"allDropdown":"AddReportProduct_allDropdown__eQYF3","dropdown":"AddReportProduct_dropdown__ukhVL"};